import { combineReducers } from 'redux';

import UserReducer from './userReducer';
import UsersReducer from './usersReducer';
import EmployeesReducer from './employeesReducer';
import TeamsReducer from './teamsReducer';
import EditingUserReducer from './editingUserReducer';
import EditingTeamReducer from './editingTeamReducer';
import SprintReducer from './sprintReducer';
import OrganizationReducer from './organizationReducer';
import OrganizationsReducer from './organizationsReducer';
import ViewingUserReducer from './viewingUserReducer';
import SprintHistoryReducer from './sprintHistoryReducer';
import EditingGoalsReducer from './editingGoalsReducer';
import TalentEvaluationsReducer from './talentEvaluationsReducer';
import MyTeamsReducer from './myTeamsReducer';
import DealReducer from './dealReducer';
import DealsReducer from './dealsReducer';
import AccountsReducer from './accountsReducer';
import AppConfigReducer from './appConfigReducer';
import OrgConfigReducer from './orgConfigReducer';
import AssessmentVersionsReducer from './assessmentVersionsReducer';
import AssessmentConfigReducer from './assessmentConfigReducer';
import AssessmentConfigsReducer from './assessmentConfigsReducer';
import MyAssessmentsReducer from './myAssessmentsReducer';
import OrganizationExportsReducer from './organizationExportsReducer';

import SalesCompetencyReviewsReducer from './salesCompetencyReviewsReducer';
import SalesCompetencyReviewItemsReducer from './salesCompetencyReviewItemsReducer';
import ViewingSalesCompetencyReviewReducer from './viewingSalesCompetencyReviewReducer';

import LocalizationsReducer from './localizationsReducer';
import ActiveLocalizationReducer from './activeLocalizationReducer';

const rootReducer = combineReducers({

  //Users
  user: UserReducer,
  employees: EmployeesReducer,
  teams: TeamsReducer,
  users: UsersReducer,//for admins
  editingUser: EditingUserReducer,
  sprint: SprintReducer,
  sprintHistory: SprintHistoryReducer,
  organization: OrganizationReducer,
  viewingUser: ViewingUserReducer,
  editingGoals: EditingGoalsReducer,
  talentEvaluations: TalentEvaluationsReducer,
  myTeams: MyTeamsReducer,
  deal: DealReducer,
  deals: DealsReducer,
  accounts: AccountsReducer,
  appConfig: AppConfigReducer,
  orgConfig: OrgConfigReducer,
  assessmentConfig: AssessmentConfigReducer,
  assessmentConfigs: AssessmentConfigsReducer,

  salesCompetencyReviews: SalesCompetencyReviewsReducer,
  salesCompetencyReviewItems: SalesCompetencyReviewItemsReducer,
  viewingSalesCompetencyReview: ViewingSalesCompetencyReviewReducer,

  //Admin
  organizations: OrganizationsReducer,
  assessmentVersions: AssessmentVersionsReducer,
  editingTeam: EditingTeamReducer,

  //Assessments
  myAssessments: MyAssessmentsReducer,

  //Assessment Admin
  organizationExports: OrganizationExportsReducer,

  allLocalizations: LocalizationsReducer,
  activeLocalization: ActiveLocalizationReducer,

});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js